<template>
<transition name="fade">
    <div v-show="(actor != null && actor.pv_id > 0)">

        <swiper ref="mySwiper" :options="swiperOption" style="margin:0px;padding:0px;">
            <swiper-slide class="mySwipe" 
                v-for="(slide, index) in imageList" 
                :key="slide.id" 
                :style="height"
                @click.native="openGallery(index, slide)">
                <img :src="slide.src" style="height:100%;">               
            </swiper-slide>
            <!--<div class="swiper-pagination" slot="pagination"></div>-->
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
        </swiper>

        <lightbox
            :images="imageList" 
            ref="lightbox"
            :show-caption="true"
            :show-light-box="false"
            :show-thumbs="true"
            :actor="actor"
        ></lightbox>

       <!-- <p>{{ actor.pv_id }}</p>
        <p>Bilder</p>
        <p>{{ medien }}</p>-->


        <div class="container">
            <div class="row my-3">
                <div class="col-12 text-center">
                    <span>
                        <a class="btn btn-primary btn-rounded"
                            target="_blank"
                            :href="urlVideoLink()">
                            <i class="fa fa-film fa-2x" style="color:white;margin: -3px 3px 0px -5px;"></i> Showreel
                        </a>

                    </span>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12 col-lg-6">

                    <div class="card vita mb-4">
                        <div class="card-header">
                            <h4 class="text-center lower-3" v-lang.vita>Vita</h4>
                        </div>

                        <!-- Filmmakers Button
                        <a class="btn-floating btn-action grey lighten-2"
                            target="_blank"
                            :href="urlVideoLink()">
                            <i class="fa fa-film fa-2x" style="color:#0188c0;"></i>
                        </a>-->
                        <a class="btn-floating btn-action grey lighten-2"
                            target="_blank"
                            :href="urlPdf()">
                            <i class="fa fa-print fa-2x" style="color:#0188c0;"></i>
                        </a>
                        
                        <div class="card-body">

                            <table class="table table-responsive vita">
                              <tbody>
                                <tr><td width="30%"><span v-lang.geburtsjahr>Geburtsjahr</span></td><td><span v-html="details[0].pv_geburtsjahr"></span></td></tr>
                                <tr><td><span v-lang.nationalitaet>Nationalität</span></td><td><span v-html="details[0].pv_nationalitaet"></span></td></tr>
                                <tr v-if="details[0].pv_groesse !== 'NULL' && details[0].pv_groesse !== ''"><td><span v-lang.groesse>Größe</span></td><td><span v-html="details[0].pv_groesse"></span></td></tr>
                                <tr v-if="details[0].pv_haarfarbe !== 'NULL' && details[0].pv_haarfarbe !== ''"><td><span v-lang.haarfarbe>Haarfarbe</span></td><td><span v-html="details[0].pv_haarfarbe"></span></td></tr>
                                <tr v-if="details[0].pv_augenfarbe !== 'NULL' && details[0].pv_augenfarbe !== ''"><td><span v-lang.augenfarbe>Augenfarbe</span></td><td><span v-html="details[0].pv_augenfarbe"></span></td></tr>
                                <tr v-if="details[0].pv_sprachen !== 'NULL' && details[0].pv_sprachen !== ''"><td><span v-lang.sprachen>Sprachen</span></td><td><span v-html="filterHtml(details[0].pv_sprachen)"></span></td></tr>
                                <tr v-if="details[0].pv_dialekte !== 'NULL' && details[0].pv_dialekte !== ''"><td><span v-lang.dialekte>Dialekte</span></td><td><span v-html="details[0].pv_dialekte"></span></td></tr>
                                <tr v-if="details[0].pv_akzent !== 'NULL' && details[0].pv_akzent !== ''"><td><span v-lang.akzent>Akzent</span></td><td><span v-html="details[0].pv_akzent"></span></td></tr>
                                <tr v-if="details[0].pv_fuehrerschein !== 'NULL' && details[0].pv_fuehrerschein !== ''"><td><span v-lang.fuehrerschein>Führerschein</span></td><td><span v-html="details[0].pv_fuehrerschein"></span></td></tr>
                                <tr v-if="details[0].pv_sport !== 'NULL' && details[0].pv_sport !== ''"><td><span v-lang.sport>Sport</span></td><td><span v-html="filterHtml(details[0].pv_sport)"></span></td></tr>
                                <tr v-if="details[0].pv_specials !== 'NULL' && details[0].pv_specials !== ''"><td><span v-lang.specials>Specials</span></td><td><span v-html="details[0].pv_specials"></span></td></tr>
                                <tr v-if="details[0].pv_musik !== 'NULL' && details[0].pv_musik !== ''"><td><span v-lang.musik>Musik</span></td><td><span v-html="details[0].pv_musik"></span></td></tr>
                                <tr v-if="details[0].pv_wohnort !== 'NULL' && details[0].pv_wohnort !== ''"><td><span v-lang.wohnort>Wohnort</span></td><td><span v-html="details[0].pv_wohnort"></span></td></tr>
                                <tr v-if="details[0].pv_wohnmoeglichkeit !== 'NULL'"><td><span v-lang.wohnmoeglichkeit>Wohnmöglichkeit</span></td><td><span v-html="details[0].pv_wohnmoeglichkeit"></span></td></tr>
                                <tr v-if="details[0].pv_web !== 'NULL' && details[0].pv_web !== ''"><td><span v-lang.website>Website</span></td><td><span v-html="details[0].pv_web"></span></td></tr>
                                <tr v-if="details[0].pv_ausbildung !== 'NULL' && details[0].pv_ausbildung !== ''"><td><span v-lang.ausbildung>Ausbildung</span></td><td><span v-html="filterHtml(details[0].pv_ausbildung)"></span></td></tr>
                              </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="card vita mb-4" 
                        v-if="hasAuftrittsart('theat') 
                        && (matchedSize === 'lg' || matchedSize === 'xl')">
                        <div class="card-header">
                            <h4 class="text-center lower-3" v-lang.theater>Theater (Auswahl)</h4>
                        </div>
                        <div class="card-body">
                            <people-info :infos="filterByAuftrittsart('theat')"></people-info>
                        </div>
                    </div>

                    <div class="card vita mb-4" 
                        v-if="hasAuftrittsart('sonst') 
                        && (matchedSize === 'lg' || matchedSize === 'xl')
                        && showSonstOnLeftColumn()">
                        <div class="card-header">
                            <h4 class="text-center lower-3" v-lang.sonstiges>Sonstiges (Auswahl)</h4>
                        </div>
                        <div class="card-body">
                            <people-info :infos="filterByAuftrittsart('sonst')"></people-info>
                        </div>
                    </div>

                </div>
                <div class="col-xs-12 col-lg-6">

                    <div class="card vita mb-4" v-if="hasAuftrittsart('award')">
                        <div class="card-header">
                            <h4 class="text-center lower-3" v-lang.auszeichnungen>Auszeichnungen</h4>
                        </div>
                        <div class="card-body">
                            <people-info :infos="filterByAuftrittsart('award')"></people-info>
                        </div>
                    </div>

                    <div class="card vita mb-4" v-if="hasAuftrittsart('film')">
                        <div class="card-header">
                            <h4 class="text-center lower-3" v-lang.filmTv>Film/TV (Auswahl)</h4>
                        </div>
                        <div class="card-body">
                            <people-info :infos="filterByAuftrittsart('film')"></people-info>
                        </div>
                    </div>

                    <div class="card vita mb-4" 
                        v-if="hasAuftrittsart('theat') 
                        && (matchedSize !== 'lg' && matchedSize !== 'xl')">
                        <div class="card-header">
                            <h4 class="text-center lower-3" v-lang.theater>Theater (Auswahl)</h4>
                        </div>
                        <div class="card-body">
                            <people-info :infos="filterByAuftrittsart('theat')"></people-info>
                        </div>
                    </div>

                    <div class="card vita mb-4" 
                        v-if="hasAuftrittsart('sonst')
                        && ((matchedSize !== 'lg' && matchedSize !== 'xl')
                         || !showSonstOnLeftColumn())">
                        <div class="card-header">
                            <h4 class="text-center lower-3" v-lang.sonstiges>Sonstiges (Auswahl)</h4>
                        </div>
                        <div class="card-body">
                            <people-info :infos="filterByAuftrittsart('sonst')"></people-info>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>

        <!--<p>Vita</p>
        <p>{{ details }}</p>
        <p>Auftrittsarten</p>
        <p>{{ auftrittsarten }}</p>
        <p>Auftritte</p>
        <p>{{ auftritte }}</p>-->


    </div>
</transition>
</template>

<script>
//import Lightbox from 'vue-image-lightbox'
import MyLightbox from './MyLightbox'
import PeopleInfo from './PeopleInfo'
import url from './../config'

export default {
    components: {
      peopleInfo: PeopleInfo,
      Lightbox: MyLightbox
      //Lightbox 
    },
    props: {
        'actor': {
            type: Object
        },          
        'details': {
            type: Array
        },
        'matchedSize': {
            type: String
        },          
        'medien': {
            type: Array,
            default : []
        },          
        'auftrittsarten': {
            type: Array
        },          
        'auftritte': {
            type: Array
        }         
    },
    computed: {
        imageList() {
                
            //this.$refs.mySwiper.swiper.update();
            //console.log("Build imageList");
            var medienlist = []; 
            this.medien.forEach(element => {
                if(this.actor.pv_id === element.pv_id) {
                    medienlist.push({
                        id: element.pm_id,
                        thumb: element.pm_bild,
                        src: element.pm_bild,
                        caption: '© ' + element.pm_copyright, 
                    });
                }
            });
            //console.log(JSON.stringify(medienlist));
            //this.$refs.mySwiper.swiper.update();
            return medienlist;
        },
        height() {
            return {
                height: this.imageHeight
            }
        },
        imageHeight() {
            if (this.matchedSize === 'xs') {
                return '250px';
            } else {
                return '400px';
            }
        }
    },
    watch: {
        medien() {
            //console.log("Watch medien");
            this.$refs.mySwiper.swiper.removeAllSlides();
            this.$refs.mySwiper.swiper.update();
        },
        imageList() {
            //console.log("Watch imageList: " + this.imageList.length + " - medien " + this.medien.length);
            var sw = this.$refs.mySwiper.swiper;
            setTimeout(function() { sw.update(); },500);
            this.$refs.mySwiper.swiper.slideTo(0);
            //console.log("slides: " + JSON.stringify(this.$refs.mySwiper.swiper.slides[0]));
            //console.log("activeIndex: " + this.$refs.mySwiper.swiper.activeIndex);
            //this.$refs.mySwiper.swiper.isBeginning = true;
            //this.$refs.mySwiper.swiper.isEnd = false;
            //this.$refs.mySwiper.swiper.allowSlideNext(true);
        }
    },
    data () {
        return {
            medienlist: [],
            swiperOption: {
                slidesPerView: 'auto',
                //loop: true,
                //loopedSlides: this.medien.length,
                centeredSlides: false,
                //effect: 'slide',
                spaceBetween: 10,
                //keyboard: {
                //    enabled: true,
                //},
                navigation: {
                   nextEl: '.swiper-button-next',
                   prevEl: '.swiper-button-prev'
                },
                autoHeight: true,
                watchSlidesProgress:true,
                watchSlidesVisibility:true,
                on: {
                    init: function () {
                        //console.log('swiper initialized');
                    },
                    slideChange(e) {
                        //alert('Slide change');
                        //console.log("Slide change, isend = " + this.isEnd);
                    }
                }
            }
        }
    },
    methods: {
        openGallery(index, slide) {
            //alert("zoom in " + JSON.stringify(slide));
            this.$refs.lightbox.showImage(index);
        },
        urlVideoLink() {
            return this.details[0].videolink != ""? this.details[0].videolink: "";
        },
        urlPdf() {
            return url.scheme + '://relaunch2018.heimanns-agentur.de/pdf/detailseite_pdf.php?id=' + this.actor.pv_id;
        },
        hasAuftrittsart(art) {
            var result = false;
            this.auftrittsarten.forEach(element => {
                if(element.pa_auftrittsart === art) {
                    result = true;
                }
            });
            return result;
        },
        filterByAuftrittsart(art) {
            var result = this.auftritte.filter(function (element) {
                return element.pa_auftrittsart === art;
            });
            //console.log("art: " + art  + " " + JSON.stringify(result.length));
            return result;
        },
        showSonstOnLeftColumn() {
            var result = true;
            if(this.hasAuftrittsart("theat") && this.hasAuftrittsart("film")) {
                //console.log("theat: " + this.filterByAuftrittsart("theat").length);
                //console.log("film: " + this.filterByAuftrittsart("film").length);
                if(this.filterByAuftrittsart("theat").length >= this.filterByAuftrittsart("film").length) {
                    result = false;
                }              
            }
            //console.log("showSonstOnLeftColumn: " + result);
            return result;
        },
        filterHtml(html) {            
            //console.log("Rein: " + html);
            var regex = new RegExp('&sect;', 'g');
            var result = html.replace(regex, ' ');

            regex = new RegExp('<br />', 'g');
            result = result.replace(regex, '<br style="line-height:25px;"/>');

            regex = new RegExp('&lt;br /&gt;', 'g');
            result = result.replace(regex, '<br style="line-height:25px;"/>');

            regex = new RegExp('\n', 'g');
            result = result.replace(regex, '<br style="line-height:25px;"/>');

            //console.log("Raus: " + result);  
            return result;    
        }
    }
    
}
</script>

<style scoped>

    .lower-3 {
        margin-top: 3px;
        margin-bottom: 3px;
    }
    .btn-primary, 
    .btn-primary:not([disabled]):not(.disabled):active {
        background-color: #0188c0!important;
        color: #fff!important;
    }
    .btn-primary:hover {
        background-color: #51b1f3!important;
    }

    .fade-enter {
        opacity: 0;     
    }
    .fade-enter-active {
        transition: opacity 3s;
    }
    .fade-leave-active {
        transition: opacity 2s;
        opacity: 0;
    }


    .mySwipe {
        /*height: 400px;*/
        background: black;
    }
    .swiper-slide {
        width: auto;
        /*height: 400px;*/
    }
    .swiper-button-prev,
    .swiper-container-rtl .swiper-button-next {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%230188c0'%2F%3E%3C%2Fsvg%3E");
    left: 10px;
    right: auto;
    }
    .swiper-button-next,
    .swiper-container-rtl .swiper-button-prev {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%230188c0'%2F%3E%3C%2Fsvg%3E");
    right: 10px;
    left: auto;
    }

    .card.vita {
        background: #eee;
        color:#757575;
        border-radius:0px;
    }
    .card.vita .card-header {
        background: #0188c0;
        color: white;
        border: 1px solid #0477a9;
        border-radius: 0px;
    }
    @media (max-width: 767px) {
        .card.vita {
            margin-left:-15px;
            margin-right:-15px;
        }
    }

    .table.vita tr>td {
        font-size:1.1rem;
        line-height:1.4rem;
        padding:6px 6px;
        
    }
    @media (max-width: 575px) {
        .table.vita tr>td {
            font-size:1rem;
            border-bottom:1px solid #eee;
        }
        .table.vita tr {    display: table;  width:100%; margin-top:10px;   }               
        .table.vita td {    display: table-row; }           
    }

    .vue-lb-content {
        margin-bottom: 0px;
        max-width: 1600px;
        position: relative;
    }
</style>



// WEBPACK FOOTER //
// src/components/PeopleDetail.vue